// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import OtherInstructions from './other-instructions';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import SpecialInstructions from './special-instructions';

const InstructionsPanelsContainer = props =>
    <div className='instructions-panels-container'>
        {!(props.partReturn.requestType.key === 'INFO') &&
            <SpecialInstructions specialInstructions={props.partReturn.specialInstructions}/>
        }
        <OtherInstructions otherInstructions={props.partReturn.otherInstructions}/>
    </div>;

InstructionsPanelsContainer.displayName = 'InstructionsPanelsContainer';
InstructionsPanelsContainer.propTypes = {
    partReturn: PropTypes.instanceOf(PartReturn).isRequired
};

export default InstructionsPanelsContainer;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/instructions-panels/instructions-panels-container.js